skrilla.controller('updateCampaignCtrl', function ($scope, searchService, modalService, cacheService, validationService) {
    $scope.validate = {}
    $scope.campaign = cacheService.getObjectOrElse("campaign", function(){modalService.dismissAll()})
    $scope.name = $scope.campaign.name;
    $scope.description = $scope.campaign.description;
    $scope.openToAllEligibleUsers = $scope.campaign.openToAllEligibleUsers;

    $scope.apply = function(){
        if(validateForm()){
           modalService.confirm("Are you sure you'd like to update campaign?", function(){
                searchService.put("campaigns/" + $scope.campaign.id, {name: $scope.name, description: $scope.description, openToAllEligibleUsers: $scope.openToAllEligibleUsers},  "Success.", true).then(function(response){
                    modalService.dismissAll()
                })
            })
        }
    }

    function validateForm(){
        var inputs = [
            validationService.buildFieldValidationObj("name", !validationService.isEmpty($scope.name), "Please enter a valid name"),
        ];
        return validationService.validateForm(inputs, $scope.validate)
    }

});
